import {
    CallStatusEnum,
    DhiraaguEventTypes,
    DHIRAAGU__EVENT__CALLS__CALL_START_TIME__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__SCHEDULED_BY__COLUMN_ID,
    DHIRAAGU__EVENT__CALLS__STATUS__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__CALLS_COUNT__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__CONTACT_NUMBER__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__CUSTOMER_NAME__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__LAST_ACTIVITY__COLUMN_ID,
    DHIRAAGU__EVENT_CONTAINER__LAST_ACTIVITY_ON__COLUMN_ID,
} from "~/domainModels/workspaceSpecific/dhiraagu";
import {
    buildScheduleCallTimeSlotOptions,
    combineScheduleDateAndTimeSlot,
    countJourneyEventsByTemplate,
} from "~/domainModels/scheduleCall/scheduleCallShared";
import type {ScheduleCallStrategy} from "~/domainModels/scheduleCall/scheduleCallStrategy";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import type {EventContainerWithEvents} from "~/utilities/apis/api";

function journeyContactNumber(journey: EventContainerWithEvents): string {
    const raw = journey.additionalColumnValues[DHIRAAGU__EVENT_CONTAINER__CONTACT_NUMBER__COLUMN_ID];
    return typeof raw === "string" ? raw.trim() : String(raw ?? "").trim();
}

function journeyCustomerName(journey: EventContainerWithEvents): string {
    const raw = journey.additionalColumnValues[DHIRAAGU__EVENT_CONTAINER__CUSTOMER_NAME__COLUMN_ID];
    return typeof raw === "string" ? raw.trim() : String(raw ?? "").trim();
}

export const dhiraaguScheduleCallStrategy: ScheduleCallStrategy = {
    callEventTemplateId: DhiraaguEventTypes.call as Uuid,
    supportsInlineModal: true,
    resolveCallEventTemplate: (eventTemplates) =>
        eventTemplates.find((template) => template.id === (DhiraaguEventTypes.call as Uuid)),
    buildCallTimeSlotOptions: buildScheduleCallTimeSlotOptions,
    combineDateAndTimeSlot: combineScheduleDateAndTimeSlot,
    buildSubmitPayload: ({journey, scheduledOnIso, workspaceUserId, now}) => {
        const phoneNumber = journeyContactNumber(journey);
        if (phoneNumber === "") {
            throw new Error("Contact number is required on the lead before scheduling a call.");
        }

        const callTemplateId = DhiraaguEventTypes.call as Uuid;
        const existingCallEventsCount = countJourneyEventsByTemplate(journey, callTemplateId);
        const customerName = journeyCustomerName(journey);

        const journeyAdditionalColumnValues: Record<Uuid, unknown> = {
            ...journey.additionalColumnValues,
            [DHIRAAGU__EVENT_CONTAINER__LAST_ACTIVITY__COLUMN_ID]: callTemplateId,
            [DHIRAAGU__EVENT_CONTAINER__LAST_ACTIVITY_ON__COLUMN_ID]: now,
            [DHIRAAGU__EVENT_CONTAINER__CALLS_COUNT__COLUMN_ID]: existingCallEventsCount + 1,
            [DHIRAAGU__EVENT_CONTAINER__CONTACT_NUMBER__COLUMN_ID]: phoneNumber,
            ...(customerName !== "" ? {[DHIRAAGU__EVENT_CONTAINER__CUSTOMER_NAME__COLUMN_ID]: customerName} : {}),
        };

        return {
            journeyUpdate: {
                additionalColumnValues: journeyAdditionalColumnValues,
            },
            eventAdditionalColumnValues: {
                [DHIRAAGU__EVENT__CALLS__SCHEDULED_BY__COLUMN_ID]: workspaceUserId,
                [DHIRAAGU__EVENT__CALLS__STATUS__COLUMN_ID]: CallStatusEnum.SCHEDULED,
                [DHIRAAGU__EVENT__CALLS__CALL_START_TIME__COLUMN_ID]: scheduledOnIso,
            },
        };
    },
};
